export default "__VITE_ASSET__DhF7iqIw__"